export default __webpack_public_path__ + "867139ea3d143a404783aa45fb7c408b.jpeg";